import { envConfig } from '~/utils/env';
import { urlWithQuery } from '~/utils/url';
import { BaseRestRepository } from './baseRestRepository';
import type {
  BankLedgerTransferDto,
  BankLedgerTransferDtoPaginationDto,
  GetBankLedgerTransfersParams,
  PostBankLedgerTransferRequestDto,
  AdjustBankLedgerTransferRequestDto,
} from '~/swagger/accounting/Api';

const BASE_URL = `${envConfig.service.accounting}/company-portal/bank-ledger-transfers`;

export class BankLedgerTransferRepository extends BaseRestRepository {
  public async getBankLedgerTransfers(params: GetBankLedgerTransfersParams): Promise<BankLedgerTransferDtoPaginationDto> {
    const url = urlWithQuery(BASE_URL, params);
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async getBankLedgerTransferById(id: string): Promise<BankLedgerTransferDto> {
    const url = `${BASE_URL}/${id}`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async createBankLedgerTransfer(data: PostBankLedgerTransferRequestDto): Promise<BankLedgerTransferDto> {
    const response = await this.fetchWithAuth(BASE_URL, {
      method: 'POST',
      body: JSON.stringify(data),
    });
    return this.getJsonResponse(response);
  }

  public async updateBankLedgerTransfer(id: string, data: AdjustBankLedgerTransferRequestDto): Promise<BankLedgerTransferDto> {
    const url = `${BASE_URL}/${id}`;
    const response = await this.fetchWithAuth(url, {
      method: 'PATCH',
      body: JSON.stringify(data),
    });
    return this.getJsonResponse(response);
  }

  public async deleteBankLedgerTransfer(id: string): Promise<void> {
    const url = `${BASE_URL}/${id}`;
    await this.fetchWithAuth(url, {
      method: 'DELETE',
    });
  }
}
